export enum AppointmentProcessState {
  Pending = 0,
  Complete = 1,
  Error = 2,
}
